// Единый конфиг графиков для всех типов устройств: МДБН / ММБ / СМБ.
// Набор графиков, тип рендера, лимиты и чекбоксы — декларативно по deviceType.

import { ChartResolution, DeviceChartType } from "../../../models/chartData";

export type ChartRender = "series" | "phase" | "stations";

export interface ModuleChartConfigEntry {
  id: string;
  render: ChartRender;
  limitKey?: "lineLimit" | "moduleLimit";
}

export type ModuleChartConfigMap = Record<
  DeviceChartType,
  ModuleChartConfigEntry[]
>;

export const MODULE_CHART_CONFIG: ModuleChartConfigMap = {
  mdbn: [
    { id: "line", render: "phase", limitKey: "lineLimit" },
    { id: "module", render: "phase", limitKey: "moduleLimit" },
    { id: "stations", render: "stations" },
  ],
  mmb: [
    { id: "line", render: "series", limitKey: "lineLimit" },
    { id: "module", render: "series", limitKey: "moduleLimit" },
    { id: "sub_devices", render: "series" },
  ],
  smb: [
    { id: "line", render: "series" },
    { id: "module", render: "series" },
    { id: "sub_devices", render: "stations" },
  ],
};

export const CHART_RESOLUTIONS: { value: ChartResolution; label: string }[] = [
  { value: "day", label: "День" },
  { value: "week", label: "Неделя" },
  { value: "month", label: "Месяц" },
];

/** Цвета фаз для графиков линии/модуля (МДБН: Фаза A/B/C, ММБ/СМБ: L1/L2/L3) */
export const PHASE_COLORS: Record<string, string> = {
  "Фаза A": "#1f77b4",
  "Фаза B": "#ff7f0e",
  "Фаза C": "#2ca02c",
  L1: "#1f77b4",
  L2: "#ff7f0e",
  L3: "#2ca02c",
};

/** Цвета станций по номеру (универсальные для МДБН и СМБ) */
export const STATION_COLORS: Record<string, string> = {
  "1": "#00008B",
  "2": "#0000CD",
  "3": "#00BFFF",
  "4": "#B0C4DE",
  "5": "#00FFFF",
  "6": "#FF1493",
  "7": "#8B0000",
  "8": "#FF0000",
  "9": "#CD5C5C",
  "10": "#FF8C00",
  "11": "#006400",
  "12": "#00FA9A",
  "13": "#ADFF2F",
  "14": "#6B8E23",
  "15": "#556B2F",
};

/** Возвращает цвет серии по имени: точное совпадение, затем по номеру станции */
export function getSeriesColor(
  seriesName: string,
  colors: Record<string, string>,
): string | undefined {
  if (colors[seriesName]) return colors[seriesName];
  const stationMatch = seriesName.match(/(\d+)$/);
  if (stationMatch && colors[stationMatch[1]]) {
    return colors[stationMatch[1]];
  }
  return undefined;
}
